module.exports = __webpack_public_path__ + "img/HM.63df9a9d.png";